import { defineNuxtPlugin } from '#imports'
import analyticsService from '@services/analytics-service'
import consentService from '@services/consent-service'
import mixpanelService from '@services/mixpanel-service'
import superPropertiesManager from '@services/mixpanel/super-properties-manager'
import appLoadTracker from '@services/mixpanel/app-load-tracker'
import playbackTracker from '@services/mixpanel/playback-tracker'
import { analyticsKey } from '@composables/use-analytics'
import { useAuthStore } from '@stores/auth'
import { publicConfig } from '@/config/runtime'

// Reads the auth store, so this runs after `@pinia/nuxt` has created Pinia.
function initMixpanel() {
    const { mixpanelToken } = publicConfig()
    if (!mixpanelToken) return

    mixpanelService.init(mixpanelToken, {
        debug: import.meta.dev,
        persistence: 'localStorage',
        track_pageview: false,
        batch_requests: true,
        opt_out_tracking_by_default: true,
    })

    consentService.restoreConsentState()

    // Auto-grant consent for logged-in users without consent (grandfathered)
    if (!consentService.hasConsent()) {
        const currentUser = useAuthStore().currentUser
        if (currentUser) {
            consentService.grantConsent('grandfathered')
        }
    }

    superPropertiesManager.initialize()

    const currentUser = useAuthStore().currentUser
    if (currentUser) {
        const memberId = currentUser.members_id?.id ? String(currentUser.members_id.id) : null
        if (memberId) {
            superPropertiesManager.updateUserStatus(true, memberId)
            mixpanelService.identify(memberId)
        }
    }

    appLoadTracker.start()

    // Report any listening from a session that crashed without a clean end (once, at boot).
    playbackTracker.recoverJournaledSession()

    playbackTracker.registerLifecycleListeners()
}

export default defineNuxtPlugin({
    name: 'analytics',
    setup(nuxtApp) {
        analyticsService.init()
        nuxtApp.vueApp.provide(analyticsKey, analyticsService)

        initMixpanel()
    },
})
